<div class="wrapper">

  <div class="title">{{'panel.home.title.general' | translate }}</div>

  <tun-recommendations-view *ngIf="enableHome" class="recommendationsContainer">

  </tun-recommendations-view>
</div>
